// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3mg8I","validationTips":"StatementDescriptor_validationTips__txJDV"};